import api from './api';

export const templateApi = {
  async getAll(tenantId: string, page = 1, limit = 20) {
    const response = await api.get(`/templates?tenantId=${tenantId}&page=${page}&limit=${limit}`);
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get(`/templates/${id}`);
    return response.data;
  },

  async create(tenantId: string, data: {
    name: string;
    description?: string;
    htmlContent: string;
  }) {
    const response = await api.post(`/templates?tenantId=${tenantId}`, data);
    return response.data;
  },

  async update(id: string, data: Partial<{
    name: string;
    description: string;
    htmlContent: string;
    isActive: boolean;
  }>) {
    const response = await api.put(`/templates/${id}`, data);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/templates/${id}`);
    return response.data;
  },
};
